import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { Link } from 'react-router';
import { setHelmetTags } from 'helpers/HelmetHelper';
import { getCreditMemberUrl, hasFullBio, getBioDescription } from '../BioHelpers';
import CastItemComponent from '../CastItem';
import castItemStyle from './CastItem.css';

class BioDetail extends Component {
  renderBio() {
    const { item, theme } = this.props;
    const longBio = getBioDescription(item);

    if (!longBio) return null;

    return <div className={theme.bio}>{longBio}</div>;
  }

  renderCastItem() {
    const { breakpoint, item: data } = this.props;

    return <CastItemComponent breakpoint={breakpoint} data={data} theme={castItemStyle} isDetail />;
  }

  renderCastItemWithNavigation() {
    const { theme } = this.props;

    return (
      <div className={theme.navigationWrapper} data-test="web-bio-detail-with-navigation">
        {this.renderLeftArrow()}
        {this.renderCastItem()}
        {this.renderRightArrow()}
      </div>
    );
  }

  renderLeftArrow() {
    const { theme, getPrevious, showId } = this.props;

    const previous = getPrevious ? getPrevious() : null;

    const url = getCreditMemberUrl({ showId, member: previous });
    if (!url || !previous) return null;

    return (
      <div className={theme.leftArrow} data-test="web-bio-detail-left-arrow">
        <Link to={url}>
          <Icon color="white" icon="arrow-left" />
        </Link>
      </div>
    );
  }

  renderRelated() {
    const { breakpoint, related, theme, showId } = this.props;
    if (!related) return null;

    const castItems = related.map(member => {
      if (!hasFullBio({ member })) return null;

      const url = getCreditMemberUrl({ showId, member });
      const castItemProps = {
        breakpoint,
        key: member.id,
        data: member,
        url,
      };
      return <CastItemComponent {...castItemProps} />;
    });

    return <div className={theme.cast}>{castItems}</div>;
  }

  renderRightArrow() {
    const { theme, getNext, showId } = this.props;

    const next = getNext ? getNext() : null;

    const url = getCreditMemberUrl({ showId, member: next });
    if (!url || !next) return null;

    return (
      <div className={theme.rightArrow} data-test="web-bio-detail-right-arrow">
        <Link to={url}>
          <Icon color="white" icon="arrow-right" />
        </Link>
      </div>
    );
  }

  render() {
    const { theme, seo } = this.props;
    return (
      <div className={theme.container} data-test="web-bio-detail">
        {setHelmetTags(seo)}
        {this.renderCastItemWithNavigation()}
        {this.renderBio()}
        {this.renderRelated()}
      </div>
    );
  }
}

BioDetail.defaultProps = {
  breakpoint: null,
  getNext: null,
  getPrevious: null,
  item: null,
  related: null,
  seo: null,
  showId: null,
};

BioDetail.propTypes = {
  breakpoint: PropTypes.string,
  getNext: PropTypes.func,
  getPrevious: PropTypes.func,
  item: PropTypes.shape({
    '@type': PropTypes.string,
    facebookUrl: PropTypes.string,
    images: PropTypes.shape({}),
    name: PropTypes.string,
    role: PropTypes.string,
    twitterUrl: PropTypes.string,
  }),
  related: PropTypes.arrayOf(PropTypes.shape({})),
  seo: PropTypes.shape({}),
  showId: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
};

export default BioDetail;
